import type { QdsOption } from '../../types/index';

/** Clone plain options with the existing choice-control identity rules. */
export function normalizeChoiceOptions(value: readonly QdsOption[]): QdsOption[] {
  const seen = new Set<string>();
  return (Array.isArray(value) ? value : []).filter(option => {
    if (!option || typeof option.value !== 'string' || !option.value.trim() || seen.has(option.value)) return false;
    seen.add(option.value); return true;
  }).map(option => ({
    value: option.value, label: typeof option.label === 'string' && option.label.trim() ? option.label.trim() : option.value,
    disabled: Boolean(option.disabled), ...(typeof option.group === 'string' ? { group: option.group } : {}),
    ...(typeof option.description === 'string' ? { description: option.description } : {}),
  }));
}
